import type { $Dictionary } from "i18next/typescript/helpers";
import { PresenceStatus } from "../../server/socket/types";
import type I18nKey from "../i18n/keys";
import type { GameNotificationBlock } from "../../server/models/game/modules/notifications/blocks";

export enum GameSocketMessageEventTypes {
    Notify = 'notify',
    Presence = 'presence',
};

export enum GameSocketNotifyMessageTypes {
    Turn = 'turn',
    TurnEnded = 'turnEnded',
    GameStarted = 'gameStarted',
    Invited = 'invited',
    Joined = 'joined',
    DeclinedInvite = 'declinedInvite',
    NotifyGameChanged = 'notifyGameChanged',
    Open = 'open',
    GameIsLive = 'gameIsLive',
    GameIsNoLongerLive = 'gameIsNoLongerLive',
    Notification = 'notification',
    RulesChanged = 'rulesChanged',
};

export interface IGameSocketNotifyMessage {
    type: GameSocketNotifyMessageTypes;
    gameId: number;
    data?: any;
    ts?: number;
};

export interface IGameSocketNotifyMessageNotificationData {
    key: I18nKey;
    blocks: Record<string, GameNotificationBlock>;
    titleKey: I18nKey;
    titleValues? : $Dictionary;
}

export type GameSocketPresenceMessage = {
    userId: number;
    status: PresenceStatus;
}
